// FilterModal.js
import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilter,
  removeFilter,
  clientFilter,
  setClientFilter,
  statusFilter,
  setStatusFilter,
  month,
  setMonth,
  year,
  setYear,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  apidata,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="clientFilter">
            <Form.Label>Client</Form.Label>

            <Form.Control
              as="select"
              value={clientFilter}
              onChange={(e) => setClientFilter(e.target.value)}
            >
              <option value="">All Clients</option>

              {[
                ...new Set(
                  (apidata || [])
                    .map((item) => item.id_client?.name?.trim())
                    .filter(Boolean),
                ),
              ]
                .sort((a, b) => a.localeCompare(b))
                .map((clientName) => (
                  <option key={clientName} value={clientName}>
                    {clientName}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="statusFilter">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </Form.Control>
          </Form.Group>

          {/* Month Filter */}
          <Form.Group controlId="monthFilter">
            <Form.Label>Month</Form.Label>
            <Form.Select
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              <option value="">Select Month</option>
              {[
                { value: "1", label: "January" },
                { value: "2", label: "February" },
                { value: "3", label: "March" },
                { value: "4", label: "April" },
                { value: "5", label: "May" },
                { value: "6", label: "June" },
                { value: "7", label: "July" },
                { value: "8", label: "August" },
                { value: "9", label: "September" },
                { value: "10", label: "October" },
                { value: "11", label: "November" },
                { value: "12", label: "December" },
              ].map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group controlId="yearFilter" className="mt-3">
            <Form.Label>Year</Form.Label>
            <Form.Select value={year} onChange={(e) => setYear(e.target.value)}>
              <option value="">Select Year</option>
              {Array.from(
                { length: 10 },
                (_, i) => new Date().getFullYear() - 3 + i,
              ).map((y) => (
                <option key={y} value={String(y)}>
                  {y}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          {/* Date Range Filter */}
          <Form.Group controlId="fromDateFilter" className="mt-3">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              max={toDate || undefined}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="toDateFilter" className="mt-3">
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              min={fromDate || undefined}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilter}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilter}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
